import type { RootState } from '/business/shared/state/store';
/*
 * Get whether the whitelabel config has been set
 */

export default (state: RootState) => {
  return state.whitelabel?.isSet;
};
